import { BUCKET_NAME } from "@/lib/constants";
import { supabase } from "@/lib/supabase";

/**
 * Generates a unique filename for uploaded images
 */
export function generateUniqueFilename(originalName: string): string {
  const fileExt = originalName.split('.').pop();
  return `${Math.random().toString(36).substring(2, 15)}_${Date.now()}.${fileExt}`;
}


export function getAssetPublicUrl(
  assetPath: string
): string {
  try {
    const { data } = supabase.storage
      .from(BUCKET_NAME)
      .getPublicUrl(assetPath);

    return data?.publicUrl || '';
  } catch (error) {
    console.error('Error getting public URL:', error);
    return '';
  }
}